import * as THREE from "../../libs/three.js/build/three.module.js";

// Klip-boks-test i pointcloud.vs: matrix pr. NODE, der fører et punkts node-lokale `position` direkte over i klip-boksens
// lokale koordinatsystem (indeni boksen: -0.5 <= x,y,z <= 0.5).
//
// Hvorfor det regnes her (CPU, float64) og ikke på GPU'en: tidligere sendtes boksens verdens->boks-matrix (`inverse`) og node'ens
// modelMatrix hver for sig til shaderen, som gangede dem i float32 (`clipBoxes[i] * modelMatrix * position`). Begge matricer har
// store translationer (UTM-koordinater, ~5e5 / ~6e6 m), så produktet er en differens mellem to meget store tal: i float32 er
// ét ULP ved 6e6 ca. 0,5 m, og hver node afrundes forskelligt - punkter nær boksens flader skiftede derfor tilfældigt mellem
// rød (fremhævet) og normal, når node-sættet/kameraet ændrede sig (Klip -> Fremhæv). Her ganges matricerne i float64; resultatet
// er et lille, lokalt tal (node-offset relativt til boksen), som float32 gengiver uden mærkbart tab. Ingen afrunding, ingen epsilon.
//
// `out` er en Float32Array med plads til clipBoxes.length * 16 elementer; boks i's matrix skrives på [16*i, 16*i + 16).
// NaN (ikke-inverterbar boks) erstattes af Infinity som før (PointCloudMaterial.setClipBoxes): punktet ender uden for boksen.
const scratch = new THREE.Matrix4();

export function composeClipBoxLocalMatrices(clipBoxes, nodeWorld, out){
	for(let i = 0; i < clipBoxes.length; i++){
		scratch.multiplyMatrices(clipBoxes[i].inverse, nodeWorld);
		const e = scratch.elements;
		const base = i * 16;
		for(let j = 0; j < 16; j++){
			const v = e[j];
			out[base + j] = Number.isNaN(v) ? Infinity : v;
		}
	}
	return out;
}
